import React from "react";
import Link from "gatsby-link";
import Helmet from "react-helmet";

import FullScreenSlider from "../components/FullScreenSlider";
import ParallaxDivider from "../components/ParallaxDivider";
import FeaturedProjectSlider from "../components/FeaturedProjectSlider";
import TrailingIcon from "../components/TrailingIcon";
import NextPageSection from "../components/NextPageSection";
import Divider from "../components/Divider";
import SocialIcons from "../components/SocialIcons";

import orangeSymbol from "./../images/mb/orange_symbol.png";
import numberLabel1 from "./../images/mb/home/label-numbers-home1.png";
import numberLabel2 from "./../images/mb/home/label-numbers-home2.png";
import sliderBG from "./../images/mb/home/mainsliderimage1.jpg";
import sliderLogo from "./../images/mb/home/mainsliderimage_logo-1.png";
import ContactForm from "../components/ContactForm"

class homePage extends React.Component {
  render() {
    const dataql = this.props.data;
    const acf = this.props.data.wordpressPage.acf;

    return (
      <div className="wow fadeIn">
        <Helmet title="Home | Moon Beyond Co" />
        <FullScreenSlider bg={sliderBG} sliderLogo={sliderLogo} />
        <Divider color="grey" />

        <div className="container logoSection">
          {/* Large Logo */}
          <div className="row wow fadeIn animated">
            <div className="col-md-6 col-sm-10 text-center center-col">
              <img
                src={
                  acf.large_logo_image.localFile.childImageSharp.resolutions.src
                }
                alt="Moon Beyond Logo"
              />
            </div>
          </div>
          {/* Description */}
          <div className="row headingDescription wow fadeIn animated">
            <div className="col-sm-6 headingDescription-title">
              <h2>
                <img
                  src={orangeSymbol}
                  className="headingDescription-titleSymbol"
                />Moon Beyond Creative
              </h2>
            </div>
            <div
              className="col-sm-6 headingDescription-description"
              dangerouslySetInnerHTML={{
                __html: acf.about_section_excerpt_description
              }}
            />
          </div>
        </div>

        <ParallaxDivider
          tagline={acf.parallax_1_text}
          taglineColor="#fff"
          bg={acf.parallax_background.localFile.childImageSharp.resolutions.src}
          trailingElementColor="orange"
        />
        <Divider color="orange" />

        <div
          className="wow fadeIn animated"
          style={{ visibility: "visible", animationName: "fadeIn" }}
        >
          <div className="headingSection">
            <div className="container">
              <div className="row text-center">
                <div className="col-xs-12">
                  <h1>
                    <img src={numberLabel1} />
                    {acf.featured_projects_title}
                  </h1>
                  <h2>{acf.featured_projects_subtitle}</h2>
                </div>
              </div>
            </div>
          </div>
        </div>

        <FeaturedProjectSlider slides={acf.featured_item_slider} />

        <div
          className="container headingDescription wow fadeIn animated"
          style={{ visibility: "visible", animationName: "fadeIn" }}
        >
          <div className="col-sm-6 headingDescription-title">
            <h2>
              <img
                src={orangeSymbol}
                className="headingDescription-titleSymbol"
              />Always Forward
            </h2>
          </div>
          <div className="col-sm-6 headingDescription-description">
            <p>
              <span style={{ fontWeight: 400 }}>
                Each brand gives us a different story and style to work with.
              </span>
            </p>
            <p>
              <span style={{ fontWeight: 400 }}> To view more </span>
              <span style={{ fontWeight: 400 }}>stellar</span>
              <span style={{ fontWeight: 400 }}> work,&nbsp;</span>visit our{" "}
              <Link to="/portfolio/">portfolio</Link>
            </p>
          </div>
          <TrailingIcon img={this.props.data.trailingIcon} />
        </div>

        <ParallaxDivider
          tagline={acf.featured_project_description}
          taglineColor="black"
          bg={dataql.parallax2.resolutions.src}
          trailingElementColor="orange"
        />
        <Divider color="black" />

        <div
          className="wow fadeIn contact-us animated"
          style={{ visibility: "visible", animationName: "fadeIn" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-xs-12 text-center headingSection">
                <h1>
                  <img src={numberLabel2} />OUR FREQUENCY
                </h1>
                <h2>Send Us A Message</h2>
              </div>
            </div>

            <div className="row contactUs__contactForm">
              <div className="col-md-4 col-sm-6">
                <p>
                  We always welcome new challenges. Tell us about your project
                  and let’s get started.
                  <br />
                  <br />
                  Don't forget to connect with us on social media!
                </p>
                <div className="text-center">
                  <SocialIcons style={{ textAlign: "center" }} />
                </div>
              </div>
              <div className="col-md-6 col-sm-6  col-md-offset-2">
                <ContactForm />
              </div>
            </div>

            <NextPageSection
              blurb={acf.next_page_blurb}
              to="../about"
              linkText={acf.next_page_button_text}
              black
            />
          </div>
        </div>
      </div>
    );
  }
}

export default homePage;

export const query = graphql`
  query HomePageQuery {
    wordpressPage(title: { eq: "Home" }) {
      id
      title
      content
      excerpt
      date
      modified
      slug
      acf {
        first_slide_background_image {
          localFile {
            childImageSharp {
              resolutions(width: 1920, quality: 80) {
                src
              }
            }
          }
        }
        large_logo_image {
          localFile {
            childImageSharp {
              resolutions(width: 450, quality: 80) {
                src
              }
            }
          }
        }
        about_section_excerpt_title
        about_section_excerpt_description
        parallax_background {
          localFile {
            childImageSharp {
              resolutions(width: 1920, quality: 80) {
                src
              }
            }
          }
        }
        parallax_1_text
        featured_projects_title
        featured_projects_subtitle
        featured_item_slider {
          title
          labels
          description
          link
          image {
            localFile {
              childImageSharp {
                resolutions(width: 960, quality: 80) {
                  src
                }
              }
            }
          }
          image2 {
            localFile {
              childImageSharp {
                resolutions(width: 960, quality: 80) {
                  src
                }
              }
            }
          }
          number_image {
            localFile {
              childImageSharp {
                resolutions(width: 248, quality: 80) {
                  src
                }
              }
            }
          }
        }
        featured_projects_description_title
        featured_projects_description_paragraph
        featured_project_parallax_background {
          localFile {
            childImageSharp {
              sizes(maxWidth: 1920, quality: 60) {
                src
              }
            }
          }
        }
        featured_project_description
        contact_us_title
        contact_subtitle
        contact_form_text
        next_page_blurb
        next_page_button_text
      }
    }

    trailingIcon: imageSharp(id: { regex: "/mb/trailing_icon_home.png/" }) {
      ...TrailingIcon
    }

    parallax2: imageSharp(id: { regex: "/mb/home_parallax2.png/" }) {
      ...HeaderBG
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js